import {useEffect, useState} from "react";
import {ActiveRaces} from './ActiveRaces';
import {useAPIData} from "../context/hooks/useAPIData";
import {OldRaces} from './OldRaces'

export const Tabs = (props) => {
    const data = useAPIData()
    const [activeTab, setActiveTab] = useState('active')
    const initializing = data.initializing

    useEffect(() => {
        if(initializing) {
            return
        }
        props.races.length === 0 ? setActiveTab('terminate') : setActiveTab('active')
    }, [initializing])

    const buttonsBar = (<div id="switchRacesTabs">
        <div id="switchRacesTabsWrapper">
            {(initializing || props.races.length > 0) && <div className={"races-tab " + (activeTab === 'active' ? 'tab-active' : '')}
                  onClick={() => setActiveTab('active')}>
                <div/>
                <p>Curse active</p>
            </div>}
            <div className={"races-tab " + (activeTab === 'terminate' ? 'tab-active' : '')}
                 onClick={() => setActiveTab('terminate')}>
                <div/>
                <p>Curse încheiate</p>
            </div>
        </div>
    </div>)
    return (
        <>
            {buttonsBar}
            {activeTab === 'active' ? <ActiveRaces races={props.races}/> : <OldRaces inactive/>}
        </>
    )
}